export const Urls = {
  baseURL: "https://api.rescuecare.in/api",
  // baseURL: "http://localhost:8080/api",
  imgURL: "https://rescucare.s3.ap-south-1.amazonaws.com/",

};
